module.exports = __webpack_public_path__ + "img/position_date.6641461e.png";